export const closestMatchIndex = (choices, searchString) => {
  return choices.map(c => c.toLowerCase()).indexOf(searchString.toLowerCase());
};
